module.exports = __webpack_public_path__ + "assets/img/2415.96ee89fc.png";